import { createGlobalStyle } from "styled-components"

const GlobalStyles = createGlobalStyle`
  /* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
  */
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol, ul {
    list-style: none;
  }
  em {
    font-style: italic;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  * {
    box-sizing: border-box;
  }
  body {
    background: #16202c;
    line-height: 1;
    font-size: 100%;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  }
  img {
    display: block;
  	width: 100%;
  	height: auto;
  }

  body.dark {
    --baseColor: #494949;
    --baseDark: var(--black);
    --borders: #434343;
    --postColor: #a4a4a4;
    --texts: var(--postColor);
    --baseTexts: #e0e0e0;
    --baseHighlight: var(--baseTexts);
    --highlight: var(--postColor);
    --mediumBackground: var(--baseDark);
    --background: var(--baseDark);
    --white: #FFFFFF;
    --black: #222;
  }

  body.light {
    --baseColor: #50a423;
    --baseDark: #333333;
    --borders: #c7c7c7;
    --postColor: #757575;
    --texts: var(--postColor);
    --baseTexts: var(--white);
    --baseHighlight: var(--baseColor);
    --highlight: var(--black);
    --mediumBackground: var(--white);
    --background: var(--white);
    --white: #FFFFFF;
    --black: #222;
  }
`
export default GlobalStyles
